import React, { forwardRef, useState, useEffect, useMemo, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import makeStyles$f from '@material-ui/core/styles/makeStyles';
import useTheme$2 from '@material-ui/core/styles/useTheme';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '@material-ui/core/styles/withTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import blue from '@material-ui/core/colors/blue';
import classNames from 'classnames';
import MaterialLink from '@material-ui/core/Link';
export { default as Link } from '@material-ui/core/Link';
import MaterialDialog from '@material-ui/core/Dialog';
export { default as Dialog } from '@material-ui/core/Dialog';
import MaterialDialogTitle from '@material-ui/core/DialogTitle';
export { default as DialogTitle } from '@material-ui/core/DialogTitle';
import MaterialDialogContent from '@material-ui/core/DialogContent';
export { default as DialogContent } from '@material-ui/core/DialogContent';
import MaterialDialogActions from '@material-ui/core/DialogActions';
export { default as DialogActions } from '@material-ui/core/DialogActions';
import MaterialAppBar from '@material-ui/core/AppBar';
export { default as AppBar } from '@material-ui/core/AppBar';
import MaterialAvatar from '@material-ui/core/Avatar';
export { default as Avatar } from '@material-ui/core/Avatar';
import MaterialBackdrop from '@material-ui/core/Backdrop';
export { default as Backdrop } from '@material-ui/core/Backdrop';
import MaterialBreadcrumbs from '@material-ui/core/Breadcrumbs';
export { default as Breadcrumbs } from '@material-ui/core/Breadcrumbs';
export { default as Button } from '@material-ui/core/Button';
import isEmpty from 'lodash/isEmpty';
import MaterialDivider from '@material-ui/core/Divider';
export { default as Divider } from '@material-ui/core/Divider';
import MaterialTypography from '@material-ui/core/Typography';
export { default as Typography } from '@material-ui/core/Typography';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import MaterialFormControlLabel from '@material-ui/core/FormControlLabel';
export { default as FormControlLabel } from '@material-ui/core/FormControlLabel';
import MaterialFormGroup from '@material-ui/core/FormGroup';
export { default as FormGroup } from '@material-ui/core/FormGroup';
import MaterialCircularProgress from '@material-ui/core/CircularProgress';
export { default as CircularProgress } from '@material-ui/core/CircularProgress';
import ReactCodeInput from 'react-code-input';
export { default as Collapse } from '@material-ui/core/Collapse';
export { default as CssBaseline } from '@material-ui/core/CssBaseline';
import moment from 'moment';
import { DatePicker as DatePicker$2, DateTimePicker as DateTimePicker$2, KeyboardTimePicker, KeyboardDatePicker as KeyboardDatePicker$1 } from '@material-ui/pickers';
export { default as Drawer } from '@material-ui/core/Drawer';
export { default as Fade } from '@material-ui/core/Fade';
import MaterialFormControl from '@material-ui/core/FormControl';
export { default as FormControl } from '@material-ui/core/FormControl';
import MaterialGrid from '@material-ui/core/Grid';
export { default as Grid } from '@material-ui/core/Grid';
import MaterialHidden from '@material-ui/core/Hidden';
export { default as Hidden } from '@material-ui/core/Hidden';
import MaterialIconButton from '@material-ui/core/IconButton';
export { default as IconButton } from '@material-ui/core/IconButton';
export { default as InputAdornment } from '@material-ui/core/InputAdornment';
import MaterialInputLabel from '@material-ui/core/InputLabel';
export { default as InputLabel } from '@material-ui/core/InputLabel';
import MaterialLinearProgress from '@material-ui/core/LinearProgress';
export { default as LinearProgress } from '@material-ui/core/LinearProgress';
export { default as List } from '@material-ui/core/List';
export { default as ListItem } from '@material-ui/core/ListItem';
export { default as ListItemAvatar } from '@material-ui/core/ListItemAvatar';
export { default as ListItemIcon } from '@material-ui/core/ListItemIcon';
export { default as ListItemSecondaryAction } from '@material-ui/core/ListItemSecondaryAction';
export { default as ListItemText } from '@material-ui/core/ListItemText';
import { useSpring, animated } from 'react-spring';
export { default as Menu } from '@material-ui/core/Menu';
export { default as MenuItem } from '@material-ui/core/MenuItem';
export { default as MobileStepper } from '@material-ui/core/MobileStepper';
import MaterialToolbar from '@material-ui/core/Toolbar';
export { default as Toolbar } from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
export { default as Paper } from '@material-ui/core/Paper';
import _, { isEmpty as isEmpty$1 } from 'lodash';
import MaterialRadio from '@material-ui/core/Radio';
export { default as Radio } from '@material-ui/core/Radio';
import MaterialSelect from '@material-ui/core/Select';
export { default as Select } from '@material-ui/core/Select';
export { default as Slider } from '@material-ui/core/Slider';
export { default as Step } from '@material-ui/core/Step';
export { default as StepButton } from '@material-ui/core/StepButton';
export { default as StepConnector } from '@material-ui/core/StepConnector';
export { default as StepContent } from '@material-ui/core/StepContent';
export { default as StepIcon } from '@material-ui/core/StepIcon';
export { default as StepLabel } from '@material-ui/core/StepLabel';
export { default as Stepper } from '@material-ui/core/Stepper';
export { default as Switch } from '@material-ui/core/Switch';
export { default as TablePagination } from '@material-ui/core/TablePagination';
export { default as Tabs } from '@material-ui/core/Tabs';
export { default as Tab } from '@material-ui/core/Tab';
import MaterialTextField from '@material-ui/core/TextField';
export { default as Tooltip } from '@material-ui/core/Tooltip';
import { Field, getIn } from 'formik';
import { Checkbox as Checkbox$2, Select, RadioGroup } from 'formik-material-ui';
import { FormLabel } from '@material-ui/core';
import Error$1 from '@material-ui/icons/Error';
import FormHelperText from '@material-ui/core/FormHelperText';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {
  makeStyles: makeStyles$f,
  useTheme: useTheme$2,
  withStyles: withStyles,
  withTheme: withTheme,
  useMediaQuery: useMediaQuery
};

// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################

var hexToRgb = function hexToRgb(input) {
  input = input + '';
  input = input.replace('#', '');
  var hexRegex = /[0-9A-Fa-f]/g;

  if (!hexRegex.test(input) || input.length !== 3 && input.length !== 6) {
    throw new Error('input is not a valid hex color.');
  }

  if (input.length === 3) {
    var _first = input[0];
    var _second = input[1];
    var _last = input[2];
    input = _first + _first + _second + _second + _last + _last;
  }

  input = input.toUpperCase(input);
  var first = input[0] + input[1];
  var second = input[2] + input[3];
  var last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};
var defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: '300',
  lineHeight: '1.5em'
};
var primaryColor = [blue[500], blue[400], blue[600], blue.A400, blue[700]];
var warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a', '#f57c00', '#faf2cc', '#fcf8e3'];
var dangerColor = ['#f44336', '#ef5350', '#e53935', '#f55a4e', '#d32f2f', '#ebcccc', '#f2dede', '#DE5E5E'];
var successColor = ['#4caf50', '#66bb6a', '#43a047', '#5cb860', '#388e3c', '#d0e9c6', '#dff0d8'];
var infoColor = ['#00acc1', '#26c6da', '#00acc1', '#00d3ee', '#0097a7', '#c4e3f3', '#d9edf7'];
var roseColor = ['#e91e63', '#ec407a', '#d81b60', '#eb3573', '#c2185b'];
var grayColor = ['#999', '#777', '#3C4858', '#AAAAAA', '#D2D2D2', '#DDD', '#555555', '#333', '#eee', '#ccc', '#e4e4e4', '#E5E5E5', '#f9f9f9', '#f5f5f5', '#495057', '#e7e7e7', '#212121', '#c8c8c8', '#505050'];
var blackColor = '#000';
var whiteColor = '#FFF';
var twitterColor = '#55acee';
var facebookColor = '#3b5998';
var googleColor = '#2F80ED';
var linkedinColor = '#0976b4';
var pinterestColor = '#cc2127';
var youtubeColor = '#e52d27';
var tumblrColor = '#35465c';
var behanceColor = '#1769ff';
var dribbbleColor = '#ea4c89';
var redditColor = '#ff4500';
({
  boxShadow: '0 10px 30px -12px rgba(' + hexToRgb(blackColor) + ', 0.42), 0 4px 25px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(blackColor) + ', 0.2)'
});
var primaryBoxShadow = {
  boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(primaryColor[0]) + ',.4)'
};
var infoBoxShadow = {
  boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(infoColor[0]) + ',.4)'
};
var successBoxShadow = {
  boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(successColor[0]) + ',.4)'
};
var warningBoxShadow = {
  boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(warningColor[0]) + ',.4)'
};
var dangerBoxShadow = {
  boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(dangerColor[0]) + ',.4)'
};
var roseBoxShadow = {
  boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(roseColor[0]) + ',.4)'
};

_objectSpread2({
  background: 'linear-gradient(60deg, ' + warningColor[1] + ', ' + warningColor[2] + ')'
}, warningBoxShadow);

_objectSpread2({
  background: 'linear-gradient(60deg, ' + successColor[1] + ', ' + successColor[2] + ')'
}, successBoxShadow);

_objectSpread2({
  background: 'linear-gradient(60deg, ' + dangerColor[1] + ', ' + dangerColor[2] + ')'
}, dangerBoxShadow);

_objectSpread2({
  background: 'linear-gradient(60deg, ' + infoColor[1] + ', ' + infoColor[2] + ')'
}, infoBoxShadow);

_objectSpread2({
  background: 'linear-gradient(60deg, ' + primaryColor[1] + ', ' + primaryColor[2] + ')'
}, primaryBoxShadow);

_objectSpread2({
  background: 'linear-gradient(60deg, ' + roseColor[1] + ', ' + roseColor[2] + ')'
}, roseBoxShadow);

({
  display: 'inline-block',
  position: 'relative',
  width: '100%',
  margin: '25px 0',
  boxShadow: '0 1px 4px 0 rgba(' + hexToRgb(blackColor) + ', 0.14)',
  borderRadius: '6px',
  color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
  background: whiteColor
});

_objectSpread2({
  margin: '0 20px 10px',
  paddingTop: '10px',
  borderTop: '1px solid ' + grayColor[8],
  height: 'auto'
}, defaultFont);
({
  border: '0',
  borderRadius: '3px',
  boxShadow: '0 10px 20px -12px rgba(' + hexToRgb(blackColor) + ', 0.42), 0 3px 20px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(blackColor) + ', 0.2)',
  padding: '10px 0',
  transition: 'all 150ms ease 0s'
});
({
  padding: '10px 15px',
  minWidth: '130px',
  color: whiteColor,
  lineHeight: '1.7em',
  background: 'rgba(' + hexToRgb(grayColor[6]) + ',0.9)',
  border: 'none',
  borderRadius: '3px',
  opacity: '1!important',
  boxShadow: '0 8px 10px 1px rgba(' + hexToRgb(blackColor) + ', 0.14), 0 3px 14px 2px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 5px 5px -3px rgba(' + hexToRgb(blackColor) + ', 0.2)',
  maxWidth: '200px',
  textAlign: 'center',
  fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '400',
  textShadow: 'none',
  textTransform: 'none',
  letterSpacing: 'normal',
  wordBreak: 'normal',
  wordSpacing: 'normal',
  wordWrap: 'normal',
  whiteSpace: 'normal',
  lineBreak: 'auto'
});
var title = {
  color: grayColor[2],
  textDecoration: 'none',
  fontWeight: '300',
  marginTop: '30px',
  marginBottom: '25px',
  minHeight: '32px',
  fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
  '& small': {
    color: grayColor[1],
    fontSize: '65%',
    fontWeight: '400',
    lineHeight: '1'
  }
};

_objectSpread2(_objectSpread2({}, title), {}, {
  marginTop: '0',
  marginBottom: '3px',
  minHeight: 'auto',
  '& a': _objectSpread2(_objectSpread2({}, title), {}, {
    marginTop: '.625rem',
    marginBottom: '0.75rem',
    minHeight: 'auto'
  })
});

var buttonStyle = {
  button: {
    minHeight: 'auto',
    minWidth: 'auto',
    backgroundColor: grayColor[0],
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(grayColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(grayColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(grayColor[0]) + ', 0.12)',
    border: 'none',
    borderRadius: '6px',
    position: 'relative',
    padding: '12px 30px',
    margin: '.3125rem 1px',
    fontSize: '12px',
    fontWeight: '400',
    textTransform: 'uppercase',
    letterSpacing: '0',
    willChange: 'box-shadow, transform',
    transition: 'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    '&:hover,&:focus': {
      color: whiteColor,
      backgroundColor: grayColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(grayColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(grayColor[0]) + ', 0.2)'
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      position: 'relative',
      display: 'inline-block',
      top: '0',
      marginTop: '-1em',
      marginBottom: '-1em',
      fontSize: '1.1rem',
      marginRight: '4px',
      verticalAlign: 'middle'
    },
    '& svg': {
      position: 'relative',
      display: 'inline-block',
      top: '0',
      width: '18px',
      height: '18px',
      marginRight: '4px',
      verticalAlign: 'middle'
    },
    '&$justIcon': {
      '& .fab,& .fas,& .far,& .fal,& .material-icons': {
        marginTop: '0px',
        position: 'absolute',
        width: '100%',
        transform: 'none',
        left: '0px',
        top: '0px',
        // height: "100%",
        lineHeight: '41px',
        fontSize: '20px'
      }
    }
  },
  fullWidth: {
    width: '100%'
  },
  primary: {
    backgroundColor: primaryColor[0],
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(primaryColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(primaryColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(primaryColor[0]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: primaryColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(primaryColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(primaryColor[0]) + ', 0.2)'
    }
  },
  info: {
    backgroundColor: infoColor[0],
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(infoColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(infoColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(infoColor[0]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: infoColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(infoColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(infoColor[0]) + ', 0.2)'
    }
  },
  success: {
    backgroundColor: successColor[0],
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(successColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(successColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(successColor[0]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: successColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(successColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(successColor[0]) + ', 0.2)'
    }
  },
  warning: {
    backgroundColor: warningColor[0],
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(warningColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(warningColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(warningColor[0]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: warningColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(warningColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(warningColor[0]) + ', 0.2)'
    }
  },
  danger: {
    backgroundColor: dangerColor[0],
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(dangerColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(dangerColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(dangerColor[0]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: dangerColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(dangerColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(dangerColor[0]) + ', 0.2)'
    }
  },
  rose: {
    backgroundColor: roseColor[0],
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(roseColor[0]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(roseColor[0]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(roseColor[0]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: roseColor[0],
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(roseColor[0]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(roseColor[0]) + ', 0.2)'
    }
  },
  white: {
    '&,&:focus,&:hover': {
      backgroundColor: whiteColor,
      color: grayColor[0]
    }
  },
  twitter: {
    backgroundColor: twitterColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(twitterColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(twitterColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(twitterColor) + ', 0.12)',
    '&:hover,&:focus,&:visited': {
      backgroundColor: twitterColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(twitterColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(twitterColor) + ', 0.2)'
    }
  },
  facebook: {
    backgroundColor: facebookColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(facebookColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(facebookColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(facebookColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: facebookColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(facebookColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(facebookColor) + ', 0.2)'
    }
  },
  google: {
    backgroundColor: googleColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(googleColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(googleColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(googleColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: googleColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(googleColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(googleColor) + ', 0.2)'
    }
  },
  linkedin: {
    backgroundColor: linkedinColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(linkedinColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(linkedinColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(linkedinColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: linkedinColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(linkedinColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(linkedinColor) + ', 0.2)'
    }
  },
  pinterest: {
    backgroundColor: pinterestColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(pinterestColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(pinterestColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(pinterestColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: pinterestColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(pinterestColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(pinterestColor) + ', 0.2)'
    }
  },
  youtube: {
    backgroundColor: youtubeColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(youtubeColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(youtubeColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(youtubeColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: youtubeColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(youtubeColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(youtubeColor) + ', 0.2)'
    }
  },
  tumblr: {
    backgroundColor: tumblrColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(tumblrColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(tumblrColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(tumblrColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: tumblrColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(tumblrColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(tumblrColor) + ', 0.2)'
    }
  },
  github: {
    backgroundColor: grayColor[7],
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(grayColor[6]) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(grayColor[6]) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(grayColor[6]) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: grayColor[7],
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(grayColor[6]) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(grayColor[6]) + ', 0.2)'
    }
  },
  behance: {
    backgroundColor: behanceColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(behanceColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(behanceColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(behanceColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: behanceColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(behanceColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(behanceColor) + ', 0.2)'
    }
  },
  dribbble: {
    backgroundColor: dribbbleColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(dribbbleColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(dribbbleColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(dribbbleColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: dribbbleColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(dribbbleColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(dribbbleColor) + ', 0.2)'
    }
  },
  reddit: {
    backgroundColor: redditColor,
    color: whiteColor,
    boxShadow: '0 2px 2px 0 rgba(' + hexToRgb(redditColor) + ', 0.14), 0 3px 1px -2px rgba(' + hexToRgb(redditColor) + ', 0.2), 0 1px 5px 0 rgba(' + hexToRgb(redditColor) + ', 0.12)',
    '&:hover,&:focus': {
      backgroundColor: redditColor,
      color: whiteColor,
      boxShadow: '0 14px 26px -12px rgba(' + hexToRgb(redditColor) + ', 0.42), 0 4px 23px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(redditColor) + ', 0.2)'
    }
  },
  simple: {
    '&,&:focus,&:hover': {
      color: whiteColor,
      background: 'transparent',
      boxShadow: 'none'
    },
    '&$primary': {
      '&,&:focus,&:hover,&:visited': {
        color: primaryColor[0]
      }
    },
    '&$info': {
      '&,&:focus,&:hover,&:visited': {
        color: infoColor[0]
      }
    },
    '&$success': {
      '&,&:focus,&:hover,&:visited': {
        color: successColor[0]
      }
    },
    '&$warning': {
      '&,&:focus,&:hover,&:visited': {
        color: warningColor[0]
      }
    },
    '&$rose': {
      '&,&:focus,&:hover,&:visited': {
        color: roseColor[0]
      }
    },
    '&$danger': {
      '&,&:focus,&:hover,&:visited': {
        color: dangerColor[0]
      }
    },
    '&$twitter': {
      '&,&:focus,&:hover,&:visited': {
        color: twitterColor
      }
    },
    '&$facebook': {
      '&,&:focus,&:hover,&:visited': {
        color: facebookColor
      }
    },
    '&$google': {
      '&,&:focus,&:hover,&:visited': {
        color: googleColor
      }
    },
    '&$linkedin': {
      '&,&:focus,&:hover,&:visited': {
        color: linkedinColor
      }
    },
    '&$pinterest': {
      '&,&:focus,&:hover,&:visited': {
        color: pinterestColor
      }
    },
    '&$youtube': {
      '&,&:focus,&:hover,&:visited': {
        color: youtubeColor
      }
    },
    '&$tumblr': {
      '&,&:focus,&:hover,&:visited': {
        color: tumblrColor
      }
    },
    '&$github': {
      '&,&:focus,&:hover,&:visited': {
        color: grayColor[7]
      }
    },
    '&$behance': {
      '&,&:focus,&:hover,&:visited': {
        color: behanceColor
      }
    },
    '&$dribbble': {
      '&,&:focus,&:hover,&:visited': {
        color: dribbbleColor
      }
    },
    '&$reddit': {
      '&,&:focus,&:hover,&:visited': {
        color: redditColor
      }
    }
  },
  transparent: {
    '&,&:focus,&:hover': {
      color: 'inherit',
      background: 'transparent',
      boxShadow: 'none'
    }
  },
  disabled: {
    opacity: '0.65',
    pointerEvents: 'none'
  },
  lg: {
    '&$justIcon': {
      '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
        marginTop: '-4px'
      }
    },
    padding: '1.125rem 2.25rem',
    fontSize: '0.875rem',
    lineHeight: '1.333333',
    borderRadius: '0.2rem'
  },
  sm: {
    '&$justIcon': {
      '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
        marginTop: '1px'
      }
    },
    padding: '0.40625rem 1.25rem',
    fontSize: '0.6875rem',
    lineHeight: '1.5',
    borderRadius: '0.2rem'
  },
  round: {
    borderRadius: '30px'
  },
  block: {
    width: '100% !important'
  },
  link: {
    '&,&:hover,&:focus': {
      backgroundColor: 'transparent',
      color: grayColor[0],
      boxShadow: 'none'
    }
  },
  justIcon: {
    paddingLeft: '12px',
    paddingRight: '12px',
    fontSize: '20px',
    height: '41px',
    minWidth: '41px',
    width: '41px',
    '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
      marginRight: '0px'
    },
    '&$lg': {
      height: '57px',
      minWidth: '57px',
      width: '57px',
      lineHeight: '56px',
      '& .fab,& .fas,& .far,& .fal,& .material-icons': {
        fontSize: '32px',
        lineHeight: '56px'
      },
      '& svg': {
        width: '32px',
        height: '32px'
      }
    },
    '&$sm': {
      height: '30px',
      minWidth: '30px',
      width: '30px',
      '& .fab,& .fas,& .far,& .fal,& .material-icons': {
        fontSize: '17px',
        lineHeight: '29px'
      },
      '& svg': {
        width: '17px',
        height: '17px'
      }
    }
  }
};

var Alert = function Alert(props) {
  var _React$createElement;

  var isAlert = props.isAlert,
      body = props.body,
      title = props.title,
      success = props.success,
      type = props.type,
      showConfirm = props.showConfirm,
      showCancel = props.showCancel,
      customButtons = props.customButtons,
      alertStyle = props.alertStyle,
      custom = props.custom;
  var classes = useStyles$q();
  if (!isAlert) return null;

  var handleConfirm = function handleConfirm() {
    return props.onConfirm();
  };

  var handleCancel = function handleCancel() {
    return props.onCancel();
  };

  return /*#__PURE__*/React.createElement(SweetAlert, (_React$createElement = {
    style: alertStyle,
    type: type,
    show: isAlert,
    success: success,
    title: title
  }, _defineProperty(_React$createElement, "style", {
    display: 'block'
  }), _defineProperty(_React$createElement, "showCancel", showCancel || showCancel === false ? showCancel : true), _defineProperty(_React$createElement, "showConfirm", showConfirm || showConfirm === false ? showConfirm : true), _defineProperty(_React$createElement, "showCloseButton", false), _defineProperty(_React$createElement, "onConfirm", handleConfirm), _defineProperty(_React$createElement, "onCancel", handleCancel), _defineProperty(_React$createElement, "confirmBtnCssClass", classes.button + ' ' + classes.success), _defineProperty(_React$createElement, "custom", custom || false), _defineProperty(_React$createElement, "customButtons", customButtons), _React$createElement), /*#__PURE__*/React.createElement("div", {
    className: classes.alert
  }, body));
};

Alert.defaultProps = {
  isAlert: false,
  title: '',
  body: '',
  type: 'default',
  onConfirm: function onConfirm() {
    return null;
  },
  onCancel: function onCancel() {
    return null;
  }
};
Alert.propTypes = {
  showCancel: PropTypes.bool,
  showConfirm: PropTypes.bool,
  isAlert: PropTypes.bool.isRequired,
  body: PropTypes.node,
  title: PropTypes.node.isRequired,
  success: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'secondary', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom', 'controlled']).isRequired,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  customButtons: PropTypes.node,
  alertStyle: PropTypes.object,
  custom: PropTypes.bool
};
var useStyles$q = styles.makeStyles(function () {
  return _objectSpread2({}, buttonStyle);
});

var ConfirmationAlert = function ConfirmationAlert(props) {
  var classes = useStyles$p();
  var title = props.title,
      titleClass = props.titleClass,
      body = props.body,
      visible = props.visible,
      noContent = props.noContent,
      yesContent = props.yesContent,
      yesAriaLabel = props.yesAriaLabel,
      noAriaLabel = props.noAriaLabel,
      onNo = props.onNo,
      onYes = props.onYes,
      showButtons = props.showButtons,
      customNoBtnClass = props.customNoBtnClass,
      customYesBtnClass = props.customYesBtnClass,
      bodyTestId = props.bodyTestId,
      buttonsTestId = props.buttonsTestId;

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React.createElement(MaterialDialog //   type={ type }
  , {
    "aria-describedby": 'alert-title',
    open: visible,
    disableEscapeKeyDown: true,
    "aria-labelledby": 'alert-body',
    role: "dialog",
    "aria-modal": "true",
    className: classes.alertCard,
    fullWidth: true,
    maxWidth: 'xs',
    classes: {
      paper: classes.paper
    }
  }, title && /*#__PURE__*/React.createElement(MaterialDialogTitle, {
    id: 'alert-title',
    className: classNames(classes.title, titleClass)
  }, title), /*#__PURE__*/React.createElement(MaterialDialogContent, {
    "data-testid": bodyTestId,
    className: classes.contentContainer,
    id: 'alert-body'
  }, body), onYes && onNo && yesContent && noContent && /*#__PURE__*/React.createElement(MaterialDialogActions, {
    className: classes.actionsContainer
  }, showButtons && /*#__PURE__*/React.createElement("div", {
    "data-testid": buttonsTestId
  }, /*#__PURE__*/React.createElement(MaterialLink, {
    component: 'button',
    role: "button",
    tabIndex: 0,
    onClick: onNo,
    underline: "none",
    "aria-label": noAriaLabel,
    className: customNoBtnClass
  }, noContent), /*#__PURE__*/React.createElement(MaterialLink, {
    component: 'button',
    autoFocus: true,
    role: "button",
    tabIndex: 0,
    onClick: onYes,
    underline: "none",
    "aria-label": yesAriaLabel,
    className: customYesBtnClass
  }, yesContent))));
};

ConfirmationAlert.propTypes = {
  type: PropTypes.oneOf(['default', 'secondary', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom', 'controlled']).isRequired,
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string,
  titleClass: PropTypes.string,
  body: PropTypes.node,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
  yesContent: PropTypes.string,
  noContent: PropTypes.string,
  yesAriaLabel: PropTypes.string,
  noAriaLabel: PropTypes.string,
  showButtons: PropTypes.bool,
  showConfirm: PropTypes.bool,
  customYesBtnClass: PropTypes.string,
  customNoBtnClass: PropTypes.string,
  bodyTestId: PropTypes.string,
  buttonsTestId: PropTypes.string
};
ConfirmationAlert.defaultProps = {
  onNo: function onNo() {},
  onYes: function onYes() {},
  showButtons: true,
  // showConfirm: false,
  title: null,
  body: '',
  type: 'default'
};
var useStyles$p = styles.makeStyles(function () {
  return _objectSpread2(_objectSpread2({}, buttonStyle), {}, {
    contentContainer: {
      zIndex: 1,
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      fontSize: '1.125em',
      fontWeight: 300,
      lineHeight: 'normal',
      textAlign: 'center',
      wordWrap: 'break-word'
    },
    actionsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      margin: '1.25em auto 0',
      zIndex: 1,
      flexWrap: 'wrap'
    },
    title: {
      textAlign: 'center'
    },
    paper: {
      padding: '1.25rem',
      maxWidth: 454
    }
  });
});

var Card = function Card(props) {
  var classes = useStyles$o();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, props.className),
    "data-testid": props['data-testid']
  }, props.children);
};

Card.propTypes = {
  children: PropTypes.any
};
var useStyles$o = styles.makeStyles(function (theme) {
  var hasNoOverride = isEmpty(theme.overrides) || isEmpty(theme.overrides.MuiCard) || isEmpty(theme.overrides.MuiCard.root);
  var cardTheme = hasNoOverride ? {} : theme.overrides.MuiCard.root;
  return {
    root: _objectSpread2(_objectSpread2({}, cardTheme), {}, {
      backgroundColor: 'white',
      borderColor: 'transparent',
      textAlign: 'left',
      borderRadius: theme.dimens.radius,
      width: '100%',
      position: 'relative',
      boxShadow: 'rgba(0,0,0,.07) 0px 0px 12px'
    })
  };
});

var makeStyles$e = styles.makeStyles;

var CardActions = function CardActions(props) {
  var classes = useStyles$n();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, props.className)
  }, /*#__PURE__*/React.createElement(MaterialDivider, null), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, props.children));
};

CardActions.propTypes = {
  children: PropTypes.any
};
var useStyles$n = makeStyles$e(function (theme) {
  return {
    root: {
      width: '100%',
      paddingTop: theme.spacing(2)
    },
    content: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  };
});

var CardContent = function CardContent(props) {
  var classes = useStyles$m();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, props.className)
  }, props.children);
};

var useStyles$m = styles.makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      padding: theme.spacing(2)
    }
  };
});
CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};

var makeStyles$d = styles.makeStyles,
    useTheme$1 = styles.useTheme;

var CardTitle = function CardTitle(props) {
  var theme = useTheme$1();
  var titleColor = !props.titleColor || props.titleColor === 'primary' ? theme.palette.primary.main : props.titleColor;
  var classes = useStyles$l({
    titleColor: titleColor
  });
  var Icon = props.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, Icon && /*#__PURE__*/React.createElement(Icon, {
    height: 26,
    width: 24,
    fill: titleColor
  })), /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'h2',
    className: classes.text,
    "data-testid": props['data-testid']
  }, props.children));
};

var useStyles$l = makeStyles$d(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    icon: {
      marginRight: theme.spacing(2),
      display: 'flex'
    },
    text: function text(_ref) {
      var titleColor = _ref.titleColor;
      return {
        color: titleColor,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: '0.0075em'
      };
    }
  };
});
CardTitle.propTypes = {
  icon: PropTypes.object,
  children: PropTypes.node,
  titleColor: PropTypes.oneOf(['primary', 'white', 'red']),
  'data-testid': PropTypes.string
};
CardTitle.defaultProps = {
  icon: null,
  titleColor: 'primary'
};

function Checkbox(props, ref) {
  if (props.label) {
    return /*#__PURE__*/React.createElement(MaterialFormGroup, {
      row: true
    }, /*#__PURE__*/React.createElement(MaterialFormControlLabel, {
      control: /*#__PURE__*/React.createElement(MaterialCheckbox, _extends({
        ref: ref,
        color: "primary"
      }, props)),
      label: props.label
    }));
  }

  return /*#__PURE__*/React.createElement(MaterialCheckbox, _extends({}, props, {
    ref: ref
  }));
}

var Checkbox$1 = /*#__PURE__*/forwardRef(Checkbox);

var CodeInput = function CodeInput(props, ref) {
  var theme = styles.useTheme();
  return /*#__PURE__*/React.createElement(ReactCodeInput, _extends({
    inputStyle: {
      height: 43,
      width: 43,
      boxSizing: 'border-box',
      borderRadius: theme.spacing(),
      border: '3px solid #c7c9cc'
    },
    inputStyleInvalid: {
      height: 43,
      width: 43,
      boxSizing: 'border-box',
      borderRadius: theme.spacing(),
      border: '3px solid red'
    },
    type: 'text',
    fields: 6
  }, props, {
    ref: ref
  }));
};

CodeInput.propTypes = {
  fields: PropTypes.number,
  inputStyle: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number', 'password']),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};
var CodeInput$1 = /*#__PURE__*/forwardRef(CodeInput);

var prefix = "id_".concat(Date.now().toString(36), "_");
var j = 0;

var useUniqueId = function useUniqueId() {
  return useState(function () {
    return prefix + ++j;
  })[0];
};

var makeStyles$c = styles.makeStyles;

var DatePicker = function DatePicker(props, ref) {
  var classes = useStyles$k();
  var uniqueId = useUniqueId();

  var label = props.label,
      name = props.name,
      format = props.format,
      disabled = props.disabled,
      valueFormat = props.valueFormat,
      value = props.value,
      error = props.error,
      rest = _objectWithoutProperties(props, ["label", "name", "format", "disabled", "valueFormat", "value", "error"]);

  var stringValue = React.useMemo(function () {
    if (!value) return null;
    return moment(value, valueFormat);
  }, [value, valueFormat]);

  var handleChange = function handleChange(dateMoment) {
    if (!format) props.onChange(dateMoment.toDate());else props.onChange(dateMoment && dateMoment.format(format));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.dateWrapper
  }, /*#__PURE__*/React.createElement(DatePicker$2, _extends({
    KeyboardButtonProps: {
      'aria-label': 'change date'
    },
    className: classNames(classes.date, !!error && classes.errorInput),
    autoOk: true,
    inputVariant: 'outlined'
  }, rest, {
    disabled: disabled,
    id: uniqueId,
    format: format || 'MM/DD/yyyy',
    onChange: handleChange,
    name: name,
    label: label,
    value: stringValue,
    ref: ref
  })), !!error && /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'body1',
    role: "alert",
    "aria-label": error,
    className: classes.errorText
  }, error));
};

DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string
};
var useStyles$k = makeStyles$c(function (theme) {
  return {
    dateWrapper: {
      height: '100%'
    },
    selectCard: {
      flex: 1,
      width: '100%',
      height: 56,
      backgroundColor: 'white',
      borderRadius: 4,
      boxShadow: "rgba(0,0,0,.07) 0px 0px 12px"
    },
    dateContainer: {
      // paddingTop: theme.spacing(),
      position: 'relative',
      height: 64 - theme.spacing(2)
    },
    date: {
      width: '100%',
      height: '100%'
    },
    errorInput: {
      '& label': {
        color: '#CF0000'
      },
      '& div.MuiInputBase-root fieldset': {
        borderColor: '#CF0000'
      }
    },
    errorText: {
      color: '#CF0000',
      paddingLeft: theme.spacing(2),
      fontSize: '0.75rem',
      marginTop: 3,
      fontWeight: 400,
      lineHeight: '1.66',
      letterSpacing: '0.03333em'
    }
  };
});
var DatePicker$1 = /*#__PURE__*/forwardRef(DatePicker);

var makeStyles$b = styles.makeStyles;

var DateTimePicker = function DateTimePicker(props, ref) {
  var classes = useStyles$j();
  var uniqueId = useUniqueId();

  var label = props.label,
      name = props.name,
      format = props.format,
      disabled = props.disabled,
      valueFormat = props.valueFormat,
      value = props.value,
      error = props.error,
      rest = _objectWithoutProperties(props, ["label", "name", "format", "disabled", "valueFormat", "value", "error"]);

  var stringValue = React.useMemo(function () {
    return moment(value, valueFormat);
  }, [value, valueFormat]);

  var handleChange = function handleChange(dateMoment) {
    if (!format) props.onChange(dateMoment.toDate());else props.onChange(dateMoment.format(format));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.dateWrapper
  }, /*#__PURE__*/React.createElement(DateTimePicker$2, _extends({
    KeyboardButtonProps: {
      'aria-label': 'change date'
    },
    className: classNames(classes.date, !!error && classes.errorInput),
    autoOk: true,
    inputVariant: 'outlined',
    ampm: true
  }, rest, {
    disabled: disabled,
    id: uniqueId,
    format: format || 'MM/DD/yyyy h:mm A',
    onChange: handleChange,
    name: name,
    label: label,
    value: stringValue,
    ref: ref
  })), !!error && /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'caption',
    className: classes.errorText
  }, error));
};

DateTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string
};
var useStyles$j = makeStyles$b(function (theme) {
  return {
    dateWrapper: {
      height: '100%'
    },
    selectCard: {
      flex: 1,
      width: '100%',
      height: 56,
      backgroundColor: 'white',
      borderRadius: 4,
      boxShadow: "rgba(0,0,0,.07) 0px 0px 12px"
    },
    dateContainer: {
      // paddingTop: theme.spacing(),
      position: 'relative',
      height: 64 - theme.spacing(2)
    },
    date: {
      width: '100%'
    },
    errorInput: {
      '& label': {
        color: 'red'
      },
      '& div.MuiInputBase-root fieldset': {
        borderColor: 'red'
      }
    },
    errorText: {
      color: 'red',
      paddingLeft: theme.spacing(2)
    }
  };
});
var DateTimePicker$1 = /*#__PURE__*/forwardRef(DateTimePicker);

var InlineLoading = function InlineLoading(props) {
  var classes = useStyles$i();
  var theme = styles.useTheme();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      reverse = _React$useState2[0];
      _React$useState2[1];

  var springStyle = useSpring({
    opacity: props.loading ? 1 : 0
  });
  var textStyle = useSpring({
    to: {
      opacity: 1,
      color: theme.palette.primary.main
    },
    from: {
      opacity: 0.5,
      color: theme.palette.primary.main
    },
    reset: reverse,
    reverse: reverse,
    duration: 10000
  });
  if (!props.loading) return null;
  return /*#__PURE__*/React.createElement(animated.div, {
    className: classNames(classes.root, props.containerClass),
    style: springStyle
  }, /*#__PURE__*/React.createElement(MaterialCircularProgress, {
    size: 20,
    variant: 'indeterminate',
    className: props.loadingIconClass
  }), !!props.loadingText && /*#__PURE__*/React.createElement(animated.div, {
    className: classes.text,
    style: textStyle
  }, /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'caption',
    className: props.loadingTextClass
  }, props.loadingText)));
};

InlineLoading.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingText: PropTypes.string,
  loadingIconClass: PropTypes.string,
  loadingTextClass: PropTypes.string,
  containerClass: PropTypes.string
};
var useStyles$i = styles.makeStyles(function (theme) {
  return {
    root: {
      flex: 1,
      zIndex: 5,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 400ms',
      padding: theme.spacing(4)
    },
    text: {
      marginTop: theme.spacing(2)
    }
  };
});

var Loading = function Loading(props) {
  var classes = useStyles$h(props);
  var theme = styles.useTheme();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      reverse = _React$useState2[0];
      _React$useState2[1];

  var textStyle = useSpring({
    to: {
      opacity: 1,
      color: theme.palette.primary.main
    },
    from: {
      opacity: 0.5,
      color: theme.palette.primary.main
    },
    reset: reverse,
    reverse: reverse,
    duration: 10000
  }); // if (!props.loading) return null;

  return /*#__PURE__*/React.createElement(MaterialBackdrop, {
    className: classes.root,
    open: props.loading,
    "data-testid": props['data-testid']
  }, /*#__PURE__*/React.createElement(MaterialCircularProgress, {
    variant: 'indeterminate',
    color: 'inherit'
  }), !!props.loadingText && /*#__PURE__*/React.createElement(animated.div, {
    className: classes.text,
    style: textStyle
  }, /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'caption'
  }, props.loadingText)));
};

Loading.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string
};
var useStyles$h = styles.makeStyles(function (theme) {
  return {
    root: function root(props) {
      return {
        zIndex: theme.zIndex.drawer + 1,
        color: props.color || 'white'
      };
    },
    text: {
      marginTop: theme.spacing(2)
    }
  };
});

var Spacer = function Spacer(props) {
  var rootStyle = React.useMemo(function () {
    if (Number.isNaN(props.flex)) return {
      flexGrow: 1,
      flex: 1
    };
    return {
      flex: props.flex,
      flexGrow: props.flex
    };
  }, [props.flex]);
  return /*#__PURE__*/React.createElement("div", {
    style: rootStyle
  }, ' ');
};

Spacer.propTypes = {
  flex: PropTypes.number
};

var CrumbSeparator = function CrumbSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.1953 4.19526C8.45565 3.93491 8.87776 3.93491 9.13811 4.19526L12.4714 7.5286C12.7318 7.78894 12.7318 8.21106 12.4714 8.4714L9.13811 11.8047C8.87776 12.0651 8.45565 12.0651 8.1953 11.8047C7.93495 11.5444 7.93495 11.1223 8.1953 10.8619L11.0572 8L8.1953 5.13807C7.93495 4.87772 7.93495 4.45561 8.1953 4.19526Z",
    fill: "#C3CAD7"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.52864 4.19526C3.78899 3.93491 4.2111 3.93491 4.47145 4.19526L7.80478 7.5286C8.06513 7.78894 8.06513 8.21106 7.80478 8.4714L4.47145 11.8047C4.2111 12.0651 3.78899 12.0651 3.52864 11.8047C3.26829 11.5444 3.26829 11.1223 3.52864 10.8619L6.39057 8L3.52864 5.13807C3.26829 4.87772 3.26829 4.45561 3.52864 4.19526Z",
    fill: "#C3CAD7"
  }));
};

CrumbSeparator.propTypes = {};

var makeStyles$a = styles.makeStyles,
    useTheme = styles.useTheme;

function NavBar(props) {
  var classes = useStyles$g();
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(MaterialAppBar, {
    position: "fixed",
    className: classes.appBar
  }, /*#__PURE__*/React.createElement(MaterialToolbar, {
    style: {
      paddingRight: 18,
      paddingLeft: 18
    },
    className: props.containerClass
  }, !!props.menu && /*#__PURE__*/React.createElement(MaterialHidden, {
    mdUp: true
  }, /*#__PURE__*/React.createElement(MaterialIconButton, {
    classes: {
      colorPrimary: classes.icon
    },
    onClick: props.onMenuClick,
    edge: "start",
    className: classes.menuButton,
    "aria-label": "menu"
  }, /*#__PURE__*/React.createElement(MenuIcon, {
    fill: theme.palette.primary.main
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.logoContainer, props.logoClass)
  }, /*#__PURE__*/React.createElement("a", {
    href: '/',
    "data-testid": props['logo-testid'],
    "aria-label": (props === null || props === void 0 ? void 0 : props.logoAriaLabel) || ''
  }, props.logo)), /*#__PURE__*/React.createElement(MaterialBreadcrumbs, {
    "aria-label": "breadcrumb",
    separator: /*#__PURE__*/React.createElement(CrumbSeparator, null)
  }, !!props.breadcrumb && (Array.isArray(props.breadcrumb) ? props.breadcrumb.map(function (crumb) {
    return /*#__PURE__*/React.createElement(MaterialLink, {
      color: 'textSecondary',
      key: crumb.link,
      href: crumb.link
    }, crumb.title);
  }) : /*#__PURE__*/React.createElement(MaterialLink, {
    color: 'textSecondary',
    key: props.breadcrumb.link,
    href: props.breadcrumb.link
  }, props.breadcrumb.title)), !!props.title && /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: "subtitle1",
    className: classes.title
  }, props.title)), /*#__PURE__*/React.createElement(Spacer, null), props.children)));
}

NavBar.propTypes = {
  onMenuClick: PropTypes.func,
  menu: PropTypes.bool,
  logo: PropTypes.node,
  title: PropTypes.string,
  breadcrumb: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  logoClass: PropTypes.string,
  containerClass: PropTypes.string
};
NavBar.defaultProps = {
  logoClass: '',
  containerClass: ''
};
var useStyles$g = makeStyles$a(function (theme) {
  return {
    root: {},
    menuButton: {
      marginRight: 0,
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main
    },
    title: {
      textAlign: 'start',
      flexGrow: 1,
      fontWeight: 'bold',
      color: theme.palette.primary.main
    },
    logoContainer: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }, theme.breakpoints.up('md'), {
      width: theme.dimens.drawerWidth,
      height: 64,
      zIndex: 101
    }),
    logo: {
      marginRight: theme.spacing(2),
      height: 30,
      paddingTop: 5
    },
    appBar: {
      zIndex: 99,
      backgroundColor: '#ffffff' // color: 'white'

    },
    icon: {
      color: theme.palette.primary.main
    }
  };
});

var makeStyles$9 = styles.makeStyles;

var ProviderHeader = function ProviderHeader(props) {
  var classes = useStyles$f(props);
  var avatarUrl = props.avatarUrl,
      name = props.name,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      nameTestId = props.nameTestId,
      specialtyTestId = props.specialtyTestId,
      visitType = props.visitType,
      scheduledType = props.scheduledType,
      titleTestId = props.titleTestId,
      modalityIcon = props.modalityIcon;
  var initials = React.useMemo(function () {
    if (!props.name) return '';
    var parts = props.name.split(' ');
    if (parts.length === 0) return '';
    var firstName = parts[0];

    if (parts.length > 1) {
      return "".concat(firstName.charAt(0)).concat(_.last(parts).charAt(0));
    } else {
      return firstName.charAt(0);
    }
  }, [props.name]);

  if (scheduledType === 'now' && !name) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.nowIcon
    }, avatarUrl), loading && /*#__PURE__*/React.createElement(MaterialLinearProgress, {
      variant: 'indeterminate',
      color: 'primary'
    }), !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.text
    }, /*#__PURE__*/React.createElement(MaterialTypography, {
      variant: 'body1',
      className: classes.title
    }, "ON DEMAND VISIT"), /*#__PURE__*/React.createElement(MaterialTypography, {
      variant: 'caption',
      className: classes.name
    }, visitType === 'medical' ? 'MedicalNow' : 'TalkNow')), /*#__PURE__*/React.createElement("div", {
      className: classes.modalityIcon
    }, modalityIcon)));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(MaterialAvatar, {
    src: avatarUrl,
    className: classes.avatar
  }, !avatarUrl ? initials : loading ? /*#__PURE__*/React.createElement(MaterialCircularProgress, {
    variant: 'indeterminate',
    size: 'small'
  }) : undefined), loading && /*#__PURE__*/React.createElement(MaterialLinearProgress, {
    variant: 'indeterminate',
    color: 'primary'
  }), !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'h2',
    className: classes.title,
    "data-testid": titleTestId
  }, scheduledType === 'now' ? 'ON DEMAND VISIT' : 'SCHEDULED VISIT'), /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'caption',
    className: classes.name,
    "data-testid": nameTestId
  }, name), /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'caption',
    className: classes.visitType,
    "data-testid": specialtyTestId
  }, visitType === 'hc' ? 'Health Coaching' : _.capitalize(visitType))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalityIcon
  }, modalityIcon)));
};

ProviderHeader.propTypes = {
  avatarUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  loading: PropTypes.bool,
  nameTestId: PropTypes.string,
  specialtyTestId: PropTypes.string,
  titleTestId: PropTypes.string,
  visitType: PropTypes.string,
  scheduledType: PropTypes.string.isRequired,
  modalityIcon: PropTypes.node
};
var useStyles$f = makeStyles$9(function (theme) {
  return {
    root: {
      display: 'flex',
      minHeight: 76,
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: "".concat(theme.spacing(2), "px, 0")
    },
    avatar: {
      height: 72,
      width: 72,
      marginRight: theme.spacing(2)
    },
    text: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center'
    },
    title: {
      color: '#FFFFFF',
      fontSize: 18,
      fontWeight: 700,
      lineHeight: 1.5,
      letterSpacing: '0.00938em'
    },
    name: {
      color: '#FFFFFF',
      fontSize: 16,
      fontWeight: 500
    },
    visitType: {
      color: '#FFFFFF',
      fontSize: 16,
      fontWeight: 400
    },
    nowIcon: {
      marginRight: 14
    },
    modalityIcon: {
      'margin': '0 0 0 auto !important',
      'alignSelf': 'flex-start',
      '& svg': {
        fill: '#FFFFFF'
      }
    }
  };
});

function TextField(props, ref) {
  var dataTestId = props['data-testid'];
  return /*#__PURE__*/React.createElement(MaterialTextField, _extends({}, props, {
    ref: ref,
    FormHelperTextProps: _objectSpread2(_objectSpread2({}, props.FormHelperTextProps), {}, {
      'data-testid': "".concat(dataTestId, "--helper")
    })
  }));
}

var TextField$1 = /*#__PURE__*/forwardRef(TextField);

var makeStyles$8 = styles.makeStyles;

var TimePicker = function TimePicker(props, ref) {
  var classes = useStyles$e();

  var error = props.error,
      format = props.format,
      value = props.value,
      label = props.label,
      valueFormat = props.valueFormat,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, ["error", "format", "value", "label", "valueFormat", "disabled"]);

  var stringValue = React.useMemo(function () {
    return moment(value, valueFormat);
  }, [value, valueFormat]);

  var handleChange = function handleChange(dateMoment) {
    if (!format) props.onChange(dateMoment.toDate());else props.onChange(dateMoment.format(format));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(KeyboardTimePicker, _extends({
    KeyboardButtonProps: {
      'aria-label': 'change date'
    },
    className: classNames(classes.date, !!error && classes.errorInput),
    autoOk: true,
    inputVariant: 'outlined',
    ampm: true
  }, rest, {
    disabled: disabled,
    id: 'datetime-picker',
    format: format || 'MM/DD/YYYY h:mm A',
    onChange: handleChange,
    name: name,
    label: label,
    ref: ref,
    value: stringValue
  })), !!error && /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'caption',
    className: classes.errorText
  }, error));
};

TimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.node,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  disabled: PropTypes.bool
};
var useStyles$e = makeStyles$8(function (theme) {
  return {
    selectCard: {
      flex: 1,
      width: '100%',
      height: 56,
      backgroundColor: 'white',
      borderRadius: 4,
      boxShadow: "rgba(0,0,0,.07) 0px 0px 12px"
    },
    dateContainer: {
      // paddingTop: theme.spacing(),
      position: 'relative',
      height: 64 - theme.spacing(2)
    },
    date: {
      width: '100%'
    },
    errorInput: {
      "& label": {
        color: 'red'
      },
      "& div.MuiInputBase-root fieldset": {
        borderColor: 'red'
      }
    },
    errorText: {
      color: 'red',
      paddingLeft: theme.spacing(2)
    }
  };
});
var TimePicker$1 = /*#__PURE__*/forwardRef(TimePicker);

var VisitCard = function VisitCard(props) {
  var providerName = props.providerName,
      providerLoading = props.providerLoading,
      providerSpecialty = props.providerSpecialty,
      providerAvatarUrl = props.providerAvatarUrl,
      content = props.content,
      actions = props.actions,
      cardTestId = props.cardTestId,
      titleTestId = props.titleTestId,
      nameTestId = props.nameTestId,
      specialtyTestId = props.specialtyTestId,
      visitType = props.visitType,
      scheduledType = props.scheduledType,
      modalityIcon = props.modalityIcon;
  var classes = useStyles$d(props);

  var renderHeader = function renderHeader() {
    if (!providerName && scheduledType !== 'now') return null;
    return /*#__PURE__*/React.createElement(ProviderHeader, {
      nameTestId: nameTestId,
      specialtyTestId: specialtyTestId,
      name: providerName,
      loading: providerLoading,
      specialty: providerSpecialty,
      avatarUrl: providerAvatarUrl,
      visitType: visitType,
      scheduledType: scheduledType,
      titleTestId: titleTestId,
      modalityIcon: modalityIcon
    });
  };

  var renderActions = function renderActions() {
    if (!actions) return null;
    return /*#__PURE__*/React.createElement(CardActions, {
      className: classNames(classes.cardActions, props.actionsClass)
    }, actions);
  };

  return /*#__PURE__*/React.createElement(Card, {
    className: classNames(classes.card, props.className),
    "data-testid": cardTestId
  }, /*#__PURE__*/React.createElement(CardContent, {
    className: classNames(classes.cardContent, props.contentClass)
  }, renderHeader(), content), renderActions());
};

VisitCard.propTypes = {
  providerName: PropTypes.string,
  providerLoading: PropTypes.bool,
  providerSpecialty: PropTypes.string,
  providerAvatarUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.node,
  actions: PropTypes.node,
  actionsClass: PropTypes.string,
  contentClass: PropTypes.string,
  className: PropTypes.string,
  cardTestId: PropTypes.string,
  titleTestId: PropTypes.string,
  nameTestId: PropTypes.string,
  specialtyTestId: PropTypes.string,
  visitType: PropTypes.string,
  scheduledType: PropTypes.string,
  modalityIcon: PropTypes.node
};
var useStyles$d = styles.makeStyles(function (theme) {
  return {
    card: {
      borderRadius: 16,
      boxShadow: '0px 12px 24px rgba(32, 69, 102, 0.2)'
    },
    cardContent: function cardContent(_ref) {
      var scheduledType = _ref.scheduledType;
      return {
        backgroundColor: scheduledType === 'now' ? '#204565' : '#006F84',
        padding: 24,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16
      };
    },
    cardActions: {
      paddingTop: 0
    }
  };
});

var Well = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = useStyles$c();
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames(classes.root, props.className),
    ref: ref
  }), props.children);
});
Well.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};
var useStyles$c = styles.makeStyles(function (theme) {
  return {
    root: {
      border: '1px solid #E7E9EC',
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    }
  };
});

var WellDetail = function WellDetail(props) {
  var classes = useStyles$b();
  return /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'body1',
    className: classNames(classes.root, props.className),
    "data-testid": props['data-testid']
  }, props.children);
};

WellDetail.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  'data-testid': PropTypes.string
};
var useStyles$b = styles.makeStyles(function (theme) {
  return {
    root: {
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: '0.25px',
      fontSize: 14,
      color: '#717173'
    }
  };
});

var WellLabel = function WellLabel(props) {
  var classes = useStyles$a();
  return /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'body1',
    className: classNames(classes.root, props.className),
    "data-testid": props['data-testid']
  }, props.children);
};

WellLabel.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  'data-testid': PropTypes.string
};
var useStyles$a = styles.makeStyles(function (theme) {
  return {
    root: {
      textTransform: 'uppercase',
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: '1.25px',
      fontSize: 14,
      color: '#717173'
    }
  };
});

var WellText = function WellText(props) {
  var classes = useStyles$9();
  return /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'body1',
    className: classNames(classes.root, props.className)
  }, props.children);
};

WellText.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};
var useStyles$9 = styles.makeStyles(function (theme) {
  return {
    root: {
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: '0.5px',
      fontSize: 16,
      color: '#272527'
    }
  };
});

var WellTitle = function WellTitle(props) {
  var classes = useStyles$8();
  return /*#__PURE__*/React.createElement(MaterialTypography, {
    variant: 'h4',
    className: classNames(classes.root, props.className),
    "data-testid": props['data-testid']
  }, props.children);
};

WellTitle.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  'data-testid': PropTypes.string
};
var useStyles$8 = styles.makeStyles(function (theme) {
  return {
    root: {
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 34,
      color: theme.palette.primary.main
    }
  };
});

var makeStyles$7 = styles.makeStyles;

var FormikCheckbox = function FormikCheckbox(props) {
  var classes = useStyles$7();
  var disabled = props.disabled,
      value = props.value,
      name = props.name,
      label = props.label;
  var dataTestId = props['data-testid'];
  return /*#__PURE__*/React.createElement(MaterialFormControl, {
    component: 'fieldset'
  }, /*#__PURE__*/React.createElement(MaterialFormGroup, null, /*#__PURE__*/React.createElement(MaterialFormControlLabel, {
    className: classes.checkbox,
    control: /*#__PURE__*/React.createElement(Field, {
      disabled: disabled,
      checked: value,
      "data-testid": dataTestId,
      type: props.type || 'checkbox',
      name: name,
      label: label,
      component: Checkbox$2
    }),
    label: /*#__PURE__*/React.createElement(FormLabel, {
      className: classes.checkboxLabel,
      component: "legend"
    }, label)
  })));
};

FormikCheckbox.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'radio', undefined]),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};
var useStyles$7 = makeStyles$7(function (theme) {
  return {
    select: {
      textAlign: 'left'
    },
    checkboxLabel: {
      color: '#1c1d1f'
    }
  };
});

var FormikCodeInput = function FormikCodeInput(props) {
  var disabled = props.disabled,
      value = props.value,
      name = props.name,
      rest = _objectWithoutProperties(props, ["disabled", "value", "name"]);

  return /*#__PURE__*/React.createElement(Field, {
    value: value,
    disabled: disabled,
    name: name,
    component: function component(_ref) {
      _ref.field;
          var form = _ref.form;
          _ref.meta;

      var handleChange = function handleChange(value) {
        var fieldval = value ? value.toUpperCase() : '';
        form.setFieldValue(name, fieldval);
      };

      return /*#__PURE__*/React.createElement(CodeInput$1, _extends({
        disabled: disabled,
        onChange: handleChange,
        value: value
      }, rest));
    }
  });
};

FormikCodeInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fields: PropTypes.number,
  inputStyle: PropTypes.object,
  className: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number', 'password']),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

var extractField = function extractField(fields, name) {
  if (!fields) return;
  if (!name.match(/\./)) return fields[name];
  var paths = name.split('.');
  return paths.reduce(function (acc, path, i) {
    var isFinalPath = i === paths.length - 1;

    if (!!acc && !!acc[path]) {
      if (isFinalPath) return acc[path];
      return acc[path].fields;
    }

    return undefined;
  }, fields);
};

var useFormikSchema = function useFormikSchema(fieldName, label, schema) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isRequired = _useState2[0],
      setIsRequired = _useState2[1];

  useEffect(function () {
    try {
      if (!schema) {
        setIsRequired(false);
      } else {
        var fields = schema.describe().fields;
        var extractedField = extractField(fields, fieldName);
        var extractedTests = extractedField.tests;
        var required = extractedTests.find(function (test) {
          return test.name === 'required';
        });
        setIsRequired(required);
      }
    } catch (e) {
      console.error(e);
    }
  }, [fieldName, schema]);
  var formattedLabel = useMemo(function () {
    if (!isRequired) return label;
    return "".concat(label, "*");
  }, [label, isRequired]);
  return {
    isRequired: isRequired,
    formattedLabel: formattedLabel
  };
};

var formatError = function formatError(error) {
  if (error && typeof error === 'string') {
    error = error.trim();

    if (!error.startsWith('Error:')) {
      return "Error: ".concat(error);
    }
  }

  return error;
};

var formatErrorWithIcon = function formatErrorWithIcon(error) {
  if (error && typeof error === 'string') {
    error = error.trim();
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Error$1, null), error);
  }

  return error;
};

var makeStyles$6 = styles.makeStyles;

var FormikDatePicker = function FormikDatePicker(props) {
  var classes = useStyles$6();

  var label = props.label,
      value = props.value,
      name = props.name,
      format = props.format,
      valueFormat = props.valueFormat,
      disabled = props.disabled,
      pickerProps = props.pickerProps,
      schema = props.schema,
      rest = _objectWithoutProperties(props, ["label", "value", "name", "format", "valueFormat", "disabled", "pickerProps", "schema"]);

  var dataTestId = props['data-testid'];

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement("div", {
    className: classes.dateContainer
  }, /*#__PURE__*/React.createElement(Field, {
    disabled: disabled,
    value: value,
    name: name,
    component: function component(_ref) {
      var field = _ref.field,
          form = _ref.form;
          _ref.meta;
      var error = form.errors[field.name];

      var handleDateChange = function handleDateChange(dateMoment) {
        console.log('handleDateChange', dateMoment);
        form.setFieldValue(name, dateMoment);
      };

      return /*#__PURE__*/React.createElement(DatePicker$1, _extends({
        "data-testid": dataTestId
      }, rest, pickerProps, {
        ampm: false,
        disabled: disabled,
        value: field.value,
        format: format || 'yyyy-MM-DD',
        valueFormat: valueFormat,
        error: formatErrorWithIcon(error),
        label: formattedLabel,
        onChange: handleDateChange,
        name: field.name
      }));
    }
  }));
};

FormikDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string
};
var useStyles$6 = makeStyles$6(function (theme) {
  return {
    dateContainer: {
      position: 'relative'
    }
  };
});

var makeStyles$5 = styles.makeStyles;

var FormikDateTimePicker = function FormikDateTimePicker(props) {
  var classes = useStyles$5();

  var label = props.label,
      value = props.value,
      name = props.name,
      format = props.format,
      valueFormat = props.valueFormat,
      disabled = props.disabled,
      pickerProps = props.pickerProps,
      schema = props.schema,
      rest = _objectWithoutProperties(props, ["label", "value", "name", "format", "valueFormat", "disabled", "pickerProps", "schema"]);

  var dataTestId = props['data-testid'];

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement("div", {
    className: classes.dateContainer
  }, /*#__PURE__*/React.createElement(Field, {
    disabled: disabled,
    value: value,
    name: name,
    component: function component(_ref) {
      var field = _ref.field,
          form = _ref.form;
          _ref.meta;
      var error = form.errors[field.name];

      var handleDateChange = function handleDateChange(dateMoment) {
        console.log('handleDateChange', dateMoment);
        form.setFieldValue(name, dateMoment);
      };

      return /*#__PURE__*/React.createElement(DateTimePicker$1, _extends({
        "data-testid": dataTestId
      }, rest, pickerProps, {
        disabled: disabled,
        value: field.value,
        format: format,
        valueFormat: valueFormat,
        error: formatErrorWithIcon(error),
        label: formattedLabel,
        onChange: handleDateChange,
        name: field.name
      }));
    }
  }));
};

FormikDateTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string
};
var useStyles$5 = makeStyles$5(function (theme) {
  return {
    dateContainer: {
      position: 'relative'
    }
  };
});

var FormikFormattedTextField = function FormikFormattedTextField(props) {
  var disabled = props.disabled,
      value = props.value,
      name = props.name,
      label = props.label,
      fieldProps = props.fieldProps,
      schema = props.schema,
      formatText = props.formatText,
      unformatText = props.unformatText,
      rest = _objectWithoutProperties(props, ["disabled", "value", "name", "label", "fieldProps", "schema", "formatText", "unformatText"]);

  var dataTestId = props['data-testid'];

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement(Field, _extends({
    disabled: disabled,
    value: value,
    name: name
  }, rest), function (renderProps) {
    var form = renderProps.form,
        meta = renderProps.meta;
    var setFieldValue = form.setFieldValue;
    var error = meta.error;
    var finalHelperTextProps = error ? _objectSpread2(_objectSpread2({}, fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.FormHelperTextProps), {}, {
      'role': 'alert',
      'aria-label': formatError(error)
    }) : fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.FormHelperTextProps;

    var handleChange = function handleChange(event) {
      var newText = event.target.value;
      setFieldValue(name, unformatText(newText));
    };

    return /*#__PURE__*/React.createElement(TextField$1, _extends({
      fullWidth: true,
      error: !!error,
      helperText: error ? formatErrorWithIcon(error) : props.helperText,
      disabled: disabled,
      value: formatText(value),
      variant: 'outlined',
      label: formattedLabel,
      "data-testid": dataTestId,
      onChange: handleChange
    }, fieldProps, {
      FormHelperTextProps: finalHelperTextProps
    }));
  });
};

FormikFormattedTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
  formatText: PropTypes.func.isRequired,
  unformatText: PropTypes.func.isRequired
};
FormikFormattedTextField.defaultProps = {
  fieldProps: {}
};

var makeStyles$4 = styles.makeStyles;

var SelectComponent = function SelectComponent(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var activeId = useUniqueId();
  var displayProps = useMemo(function () {
    if (isExpanded) {
      return {
        'aria-expanded': isExpanded,
        'aria-activedescendant': activeId
      };
    }

    return {
      'aria-expanded': isExpanded
    };
  }, [isExpanded]);
  return /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    SelectDisplayProps: displayProps,
    MenuProps: {
      MenuListProps: {
        id: activeId
      }
    },
    onOpen: function onOpen() {
      return setIsExpanded(true);
    },
    onClose: function onClose() {
      return setIsExpanded(false);
    }
  }));
};

var FormikSelect = function FormikSelect(props) {
  var classes = useStyles$4();
  var uniqueId = useUniqueId();

  var disabled = props.disabled,
      value = props.value,
      name = props.name,
      label = props.label;
      props.gridProps;
      var errors = props.errors,
      touched = props.touched;
      props.loading;
      var schema = props.schema,
      rest = _objectWithoutProperties(props, ["disabled", "value", "name", "label", "gridProps", "errors", "touched", "loading", "schema"]);

  var dataTestId = props['data-testid'];

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  var fieldError = getIn(errors, name);
  var showError = getIn(touched, name) && !!fieldError;
  return /*#__PURE__*/React.createElement(MaterialFormControl, {
    variant: 'outlined',
    fullWidth: true,
    error: showError && fieldError
  }, /*#__PURE__*/React.createElement(MaterialInputLabel, {
    variant: 'outlined',
    id: uniqueId,
    error: showError
  }, formattedLabel), /*#__PURE__*/React.createElement(Field, _extends({
    "data-testid": dataTestId
  }, rest, {
    fullWidth: true,
    value: value,
    disabled: disabled,
    variant: 'outlined',
    label: formattedLabel,
    name: name,
    labelId: uniqueId,
    className: classes.select,
    component: SelectComponent
  }), props.children), showError && /*#__PURE__*/React.createElement(FormHelperText, {
    role: "alert",
    "aria-label": formatError(fieldError)
  }, formatErrorWithIcon(fieldError)));
};

FormikSelect.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  errors: PropTypes.object,
  touched: PropTypes.object
};
var useStyles$4 = makeStyles$4(function (theme) {
  return {
    select: {
      textAlign: 'left'
    }
  };
});

var transformField = function transformField(_ref) {
  var disabled = _ref.disabled,
      _ref$field = _ref.field,
      fieldOnBlur = _ref$field.onBlur,
      field = _objectWithoutProperties(_ref$field, ["onBlur"]),
      _ref$form = _ref.form,
      isSubmitting = _ref$form.isSubmitting,
      touched = _ref$form.touched,
      errors = _ref$form.errors,
      onBlur = _ref.onBlur,
      helperText = _ref.helperText,
      FormHelperTextProps = _ref.FormHelperTextProps,
      props = _objectWithoutProperties(_ref, ["disabled", "field", "form", "onBlur", "helperText", "FormHelperTextProps"]);

  var fieldError = getIn(errors, field.name);
  var showError = getIn(touched, field.name) && !!fieldError;
  var finalHelperTextProps = showError ? _objectSpread2(_objectSpread2({}, FormHelperTextProps), {}, {
    'role': 'alert',
    'aria-label': formatError(fieldError)
  }) : FormHelperTextProps;
  return _objectSpread2(_objectSpread2({
    error: showError,
    helperText: showError ? formatErrorWithIcon(fieldError) : helperText,
    FormHelperTextProps: finalHelperTextProps,
    disabled: disabled !== null && disabled !== void 0 ? disabled : isSubmitting,
    onBlur: onBlur !== null && onBlur !== void 0 ? onBlur : function (e) {
      fieldOnBlur(e !== null && e !== void 0 ? e : field.name);
    }
  }, field), props);
};

var NewTextField = function NewTextField(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React.createElement(TextField$1, transformField(props), children);
};

NewTextField.propTypes = {
  children: PropTypes.any
};

// import { TextField } from "formik-material-ui";

var FormikTextField = function FormikTextField(props) {
  var disabled = props.disabled,
      value = props.value,
      name = props.name,
      label = props.label,
      fieldProps = props.fieldProps,
      schema = props.schema,
      rest = _objectWithoutProperties(props, ["disabled", "value", "name", "label", "fieldProps", "schema"]);

  var dataTestId = props['data-testid'];

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement(Field, _extends({
    fullWidth: true,
    disabled: disabled,
    value: value,
    variant: 'outlined',
    name: name,
    label: formattedLabel,
    "data-testid": dataTestId
  }, rest, fieldProps, {
    component: NewTextField
  }));
};

FormikTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object
};
FormikTextField.defaultProps = {
  fieldProps: {}
};

var makeStyles$3 = styles.makeStyles;

var FormikTimePicker = function FormikTimePicker(props) {
  var classes = useStyles$3();

  var label = props.label,
      value = props.value,
      name = props.name,
      format = props.format,
      valueFormat = props.valueFormat,
      disabled = props.disabled,
      pickerProps = props.pickerProps,
      schema = props.schema,
      rest = _objectWithoutProperties(props, ["label", "value", "name", "format", "valueFormat", "disabled", "pickerProps", "schema"]);

  var dataTestId = props['data-testid'];

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement("div", {
    className: classes.dateContainer
  }, /*#__PURE__*/React.createElement(Field, {
    disabled: disabled,
    value: value,
    name: name,
    component: function component(_ref) {
      var field = _ref.field,
          form = _ref.form;
          _ref.meta;
      var error = form.errors[field.name];

      var handleDateChange = function handleDateChange(dateMoment) {
        console.log('handleDateChange', dateMoment);
        form.setFieldValue(name, dateMoment);
      };

      return /*#__PURE__*/React.createElement(TimePicker$1, _extends({
        "data-testid": dataTestId
      }, rest, pickerProps, {
        disabled: disabled,
        value: field.value,
        format: format,
        valueFormat: valueFormat,
        error: formatErrorWithIcon(error),
        label: formattedLabel,
        onChange: handleDateChange,
        name: field.name
      }));
    }
  }));
};

FormikTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  pickerProps: PropTypes.object,
  minDate: PropTypes.any,
  maxDate: PropTypes.any
};
var useStyles$3 = makeStyles$3(function (theme) {
  return {
    dateContainer: {
      position: 'relative'
    }
  };
});

var GridCheckbox = function GridCheckbox(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(Checkbox$1, props));
};

GridCheckbox.propTypes = {
  gridProps: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool
};

var makeStyles$2 = styles.makeStyles;

var GridDatePicker = function GridDatePicker(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  var classes = useStyles$2();
  var label = props.label,
      value = props.value,
      name = props.name,
      format = props.format,
      valueFormat = props.valueFormat,
      disabled = props.disabled,
      pickerProps = props.pickerProps,
      error = props.error;
  var dataTestId = props['data-testid'];

  var handleDateChange = function handleDateChange(dateMoment) {
    console.log('handleDateChange', dateMoment);
    props.onChange(name, dateMoment);
  };

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.dateContainer, props.className)
  }, /*#__PURE__*/React.createElement(DatePicker$1, _extends({
    "data-testid": dataTestId
  }, props, pickerProps, {
    ampm: false,
    disabled: disabled,
    value: value,
    format: format || 'yyyy-MM-DD',
    valueFormat: valueFormat,
    error: error,
    label: label,
    onChange: handleDateChange,
    name: name
  }))));
};

var useStyles$2 = makeStyles$2(function (theme) {
  return {
    dateContainer: {
      position: 'relative'
    }
  };
});
GridDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

var GridSelect = function GridSelect(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  var error = props.error,
      id = props.id,
      label = props.label;
  var helperTextId = useUniqueId();
  var selectId = useUniqueId();
  var finalSelectId = id || selectId;
  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(MaterialFormControl, {
    variant: 'outlined',
    fullWidth: true,
    error: !!error
  }, /*#__PURE__*/React.createElement(MaterialInputLabel, {
    htmlFor: finalSelectId,
    variant: 'outlined',
    error: !!error
  }, label), /*#__PURE__*/React.createElement(MaterialSelect, _extends({}, props, {
    id: finalSelectId,
    "aria-describedby": helperTextId
  })), !!error && /*#__PURE__*/React.createElement(FormHelperText, {
    id: helperTextId,
    role: "alert",
    "aria-label": formatError(error)
  }, formatError(error))));
};

GridSelect.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  gridProps: PropTypes.object.isRequired,
  error: PropTypes.object
};

var GridTextField = function GridTextField(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(TextField$1, props));
};

GridTextField.propTypes = {
  gridProps: PropTypes.object.isRequired
};

var GridFormikCheckbox = function GridFormikCheckbox(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikCheckbox, props));
};

GridFormikCheckbox.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'radio', undefined]),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  gridProps: PropTypes.object.isRequired
};

var GridFormikDatePicker$1 = function GridFormikDatePicker(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikDatePicker, props));
};

GridFormikDatePicker$1.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object.isRequired
};

var wrapError = function wrapError(err) {
  return err && typeof err === 'string' ? /*#__PURE__*/React.createElement(FormHelperText, {
    role: "alert",
    "aria-label": formatError(err)
  }, formatError(err)) : err;
};

var makeStyles$1 = styles.makeStyles;

var KeyboardDatePicker = function KeyboardDatePicker(props) {
  var classes = useStyles$1();

  var error = props.error,
      disabled = props.disabled,
      format = props.format,
      onChange = props.onChange,
      name = props.name,
      label = props.label,
      id = props.id,
      value = props.value,
      invalidDateMessage = props.invalidDateMessage,
      minDateMessage = props.minDateMessage,
      maxDateMessage = props.maxDateMessage,
      rest = _objectWithoutProperties(props, ["error", "disabled", "format", "onChange", "name", "label", "id", "value", "invalidDateMessage", "minDateMessage", "maxDateMessage"]);

  return /*#__PURE__*/React.createElement(KeyboardDatePicker$1, _extends({}, rest, {
    KeyboardButtonProps: {
      'aria-label': 'change date'
    },
    className: classNames(classes.date, !!error && classes.errorInput),
    inputVariant: 'outlined',
    disabled: disabled,
    id: id || 'date-picker',
    format: format || 'yyyy/MM/DD',
    onChange: onChange,
    name: name,
    label: label,
    value: value,
    invalidDateMessage: wrapError(invalidDateMessage),
    minDateMessage: wrapError(minDateMessage),
    maxDateMessage: wrapError(maxDateMessage),
    clearable: true
  }));
};

KeyboardDatePicker.propTypes = {
  'label': PropTypes.string.isRequired,
  'value': PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  'disabled': PropTypes.bool,
  'name': PropTypes.string.isRequired,
  'format': PropTypes.string,
  'valueFormat': PropTypes.string,
  'data-testid': PropTypes.string,
  'error': PropTypes.bool,
  'onChange': PropTypes.func,
  'id': PropTypes.string,
  'invalidDateMessage': PropTypes.node,
  'minDateMessage': PropTypes.node,
  'maxDateMessage': PropTypes.node
};
var useStyles$1 = makeStyles$1(function () {
  return {
    date: {
      width: '100%'
    },
    errorInput: {
      '& label': {
        color: '#CF0000'
      },
      '& div.MuiInputBase-root fieldset': {
        borderColor: '#CF0000'
      },
      '& p.MuiFormHelperText-root': {
        color: '#CF0000'
      }
    }
  };
});

var Comp = function Comp(myProps) {
  var field = myProps.field,
      form = myProps.form,
      invalidDateMessage = myProps.invalidDateMessage,
      format = myProps.format,
      label = myProps.label,
      fieldProps = myProps.fieldProps,
      other = _objectWithoutProperties(myProps, ["field", "form", "invalidDateMessage", "format", "label", "fieldProps"]);

  var invalidMessage = invalidDateMessage || "".concat(label, " is invalid");
  var dataTestId = fieldProps['data-testid'];

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      displayDate = _useState2[0],
      setDisplayDate = _useState2[1];

  var hasTouched = form.touched[field.name];
  var currentError = form.errors[field.name];

  var onAcceptDate = function onAcceptDate(dateMoment) {
    if (isEmpty$1(field.value) || !moment(field.value).isSame(dateMoment)) {
      form.setFieldValue(field.name, dateMoment.format(format));
    }
  };

  var onBlur = function onBlur(evt) {
    if (isEmpty$1(evt.target.value)) {
      form.setFieldValue(field.name, '');
    }
  };

  var onChangeDate = function onChangeDate(selectedDate, selectedValue) {
    setDisplayDate(selectedValue);

    if (selectedDate !== null && selectedDate !== void 0 && selectedDate.isValid() || isEmpty$1(selectedValue)) {
      form.setFieldValue(field.name, selectedValue);
      return;
    }

    if (isEmpty$1(selectedValue)) {
      form.setFieldValue(field.name, '');
      form.setFieldError(field.name, '');
    } else if (form.touched[field.name]) {
      form.setFieldError(field.name, invalidMessage);
    } else {
      form.setFieldError(field.name, undefined);
    }
  };

  var onError = function onError(error) {
    if (!currentError && error !== currentError && !isEmpty$1(error) && form.touched[field.name]) {
      form.setFieldError(field.name, error);
    }
  };

  var finalHelperTextProps = currentError ? _objectSpread2(_objectSpread2({}, other === null || other === void 0 ? void 0 : other.FormHelperTextProps), {}, {
    'role': 'alert',
    'aria-label': formatError(currentError)
  }) : other === null || other === void 0 ? void 0 : other.FormHelperTextProps;
  return /*#__PURE__*/React.createElement(KeyboardDatePicker, _extends({}, other, {
    "data-testid": dataTestId,
    inputValue: displayDate,
    onAccept: onAcceptDate,
    onBlur: onBlur,
    onError: onError,
    label: label,
    helperText: hasTouched && formatErrorWithIcon(currentError),
    FormHelperTextProps: finalHelperTextProps,
    error: hasTouched && !!currentError,
    format: format,
    onChange: onChangeDate,
    name: field.name
  }));
};

Comp.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};

var FormikKeyboardDatePicker = function FormikKeyboardDatePicker(props) {
  var value = props.value,
      name = props.name,
      disabled = props.disabled,
      label = props.label,
      schema = props.schema;
      props.gridProps;
      var fieldProps = props.fieldProps,
      rest = _objectWithoutProperties(props, ["value", "name", "disabled", "label", "schema", "gridProps", "fieldProps"]);

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement(Field, _extends({
    fieldProps: fieldProps,
    fullWidth: true,
    label: formattedLabel,
    disabled: disabled,
    value: value,
    name: name
  }, rest, {
    component: Comp
  }));
};

FormikKeyboardDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object,
  fieldProps: PropTypes.object
};

var GridFormikKeyboardDatePicker = function GridFormikKeyboardDatePicker(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikKeyboardDatePicker, props));
};

GridFormikKeyboardDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object,
  fieldProps: PropTypes.object
};

var GridFormikDatePicker = function GridFormikDatePicker(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikDateTimePicker, props));
};

GridFormikDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object.isRequired
};

var GridFormikFormattedTextField = function GridFormikFormattedTextField(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikFormattedTextField, props));
};

GridFormikFormattedTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
  gridProps: PropTypes.object.isRequired,
  formatText: PropTypes.func.isRequired,
  unformatText: PropTypes.func.isRequired
};

var GridFormikSelect = function GridFormikSelect(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikSelect, props));
};

GridFormikSelect.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  gridProps: PropTypes.object.isRequired
};

var GridFormikTextField = function GridFormikTextField(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikTextField, props));
};

GridFormikTextField.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  fieldProps: PropTypes.object,
  gridProps: PropTypes.object.isRequired
};

var GridFormikTimePicker = function GridFormikTimePicker(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikTimePicker, props));
};

GridFormikTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  pickerProps: PropTypes.object,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  gridProps: PropTypes.object.isRequired
};

var makeStyles = styles.makeStyles;

var CheckboxGroup = function CheckboxGroup(_ref) {
  var field = _ref.field,
      form = _ref.form;
      _ref.meta;
      var props = _objectWithoutProperties(_ref, ["field", "form", "meta"]);

  var options = props.options,
      value = props.value,
      disabled = props.disabled;
  var dataTestId = props['data-testid'];
  var handleChange = useCallback(function (option) {
    return function (event) {
      if (event.target.checked) {
        form.setFieldValue(field.name, [].concat(_toConsumableArray(field.value), [option.value]));
      } else {
        var list = _toConsumableArray(field.value);

        var index = list.indexOf(option.value);

        if (index >= 0) {
          list.splice(index, 1);
        }

        form.setFieldValue(field.name, list);
      }
    };
  }, [options, field.value, field.name]);
  return /*#__PURE__*/React.createElement(Fragment, null, options.map(function (option, index) {
    var _value$includes;

    return /*#__PURE__*/React.createElement(Checkbox$1, {
      color: 'primary',
      key: "".concat(name, "-").concat(index),
      value: option.value,
      label: option.label,
      onChange: handleChange(option),
      checked: !!(value !== null && value !== void 0 && (_value$includes = value.includes) !== null && _value$includes !== void 0 && _value$includes.call(value, option.value)),
      "data-testid": "".concat(dataTestId || 'option', "-").concat(index),
      disabled: disabled || option.disabled || false
    });
  }));
};

var FormikRadioGroup = function FormikRadioGroup(props) {
  var disabled = props.disabled,
      value = props.value,
      name = props.name,
      label = props.label,
      options = props.options,
      labelClass = props.labelClass,
      labelPlacement = props.labelPlacement,
      alignment = props.alignment,
      schema = props.schema,
      multiple = props.multiple,
      ariaLabel = props.ariaLabel,
      legendClass = props.legendClass;
  var dataTestId = props['data-testid'];
  var classes = useStyles();

  var _useFormikSchema = useFormikSchema(name, label, schema),
      formattedLabel = _useFormikSchema.formattedLabel;

  return /*#__PURE__*/React.createElement(MaterialFormControl, {
    component: 'fieldset'
  }, /*#__PURE__*/React.createElement(MaterialFormGroup, null, /*#__PURE__*/React.createElement(MaterialFormControlLabel, {
    className: classNames(labelClass, classes.label),
    labelPlacement: labelPlacement,
    control: /*#__PURE__*/React.createElement(Field, {
      disabled: disabled,
      value: value,
      "data-testid": dataTestId,
      name: name,
      options: options,
      component: multiple ? CheckboxGroup : RadioGroup,
      row: alignment === 'horizontal',
      "aria-label": ariaLabel
    }, !multiple && options.map(function (option, index) {
      return /*#__PURE__*/React.createElement(MaterialFormControlLabel, {
        key: "".concat(name, "-").concat(index),
        value: option.value,
        checked: multiple ? (value || []).includes(option.value) : value === option.value,
        control: /*#__PURE__*/React.createElement(MaterialRadio, {
          "data-testid": "".concat(dataTestId || 'option', "-").concat(index),
          disabled: disabled || option.disabled || false
        }),
        label: option.label
      });
    })),
    label: /*#__PURE__*/React.createElement(FormLabel, {
      component: "legend",
      className: classNames(classes.labelLegend, legendClass)
    }, formattedLabel)
  })));
};

FormikRadioGroup.propTypes = {
  'disabled': PropTypes.bool,
  'value': PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  'multiple': PropTypes.bool,
  'name': PropTypes.string.isRequired,
  'options': PropTypes.array.isRequired,
  'data-testid': PropTypes.string,
  'label': PropTypes.string,
  'labelClass': PropTypes.string,
  'legendClass': PropTypes.string,
  'labelPlacement': PropTypes.string,
  'schema': PropTypes.object,
  'alignment': PropTypes.oneOf(['horizontal', 'vertical'])
};
FormikRadioGroup.defaultProps = {
  label: '',
  labelClass: '',
  labelPlacement: 'top',
  alignment: 'vertical'
};
var useStyles = makeStyles(function (theme) {
  return {
    label: {
      alignItems: 'flex-start'
    },
    labelLegend: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      fontSize: 20
    }
  };
});

var GridFormikRadioGroup = function GridFormikRadioGroup(_ref) {
  var gridProps = _ref.gridProps,
      props = _objectWithoutProperties(_ref, ["gridProps"]);

  return /*#__PURE__*/React.createElement(MaterialGrid, _extends({
    item: true
  }, gridProps), /*#__PURE__*/React.createElement(FormikRadioGroup, props));
};

GridFormikRadioGroup.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  'data-testid': PropTypes.string,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  labelPlacement: PropTypes.string,
  gridProps: PropTypes.object.isRequired,
  alignment: PropTypes.oneOf(['horizontal', 'vertical'])
};

export { Alert, Card, CardActions, CardContent, CardTitle, Checkbox$1 as Checkbox, CodeInput$1 as CodeInput, ConfirmationAlert, DatePicker$1 as DatePicker, DateTimePicker$1 as DateTimePicker, FormikCheckbox, FormikCodeInput, FormikDatePicker, FormikDateTimePicker, FormikFormattedTextField, FormikSelect, FormikTextField, FormikTimePicker, GridCheckbox, GridDatePicker, GridFormikCheckbox, GridFormikDatePicker$1 as GridFormikDatePicker, GridFormikDatePicker as GridFormikDateTimePicker, GridFormikFormattedTextField, GridFormikKeyboardDatePicker, GridFormikRadioGroup, GridFormikSelect, GridFormikTextField, GridFormikTimePicker, GridSelect, GridTextField, InlineLoading, Loading, NavBar, ProviderHeader, Spacer, TextField$1 as TextField, TimePicker$1 as TimePicker, VisitCard, Well, WellDetail, WellLabel, WellText, WellTitle, styles };
